import React, { useState } from 'react';

import { Link, useLocation } from 'react-router-dom';
import LogoutModal from '../LogoutModal/LogoutModal';
import './AccountSidebar.scss';

const sidebarList = [
  {
    lable: 'Profile',
    url: '/account',
  },
  {
    lable: 'Balances & Transactions',
    url: '/account/transactions',
  },
  {
    lable: 'Payment Methods',
    url: '/account/payment',
  },
  {
    lable: 'Documents',
    url: '/account/documents',
  },
  {
    lable: 'Settings',
    url: '/account/settings',
  },
  {
    lable: 'Help Center',
    url: '/account/help-center',
  },
  {
    lable: 'Legal',
    url: '/account/legal',
  },
];

const AccountSidebar = () => {
  const [logoutModal, setLogoutModal] = useState(false);

  const location = useLocation();

  return (
    <div className='accountsidebar'>
      <ul className='accountsidebar__list'>
        {sidebarList.map((linkName, index) => (
          <li className={`accountsidebar__list__item ${linkName.url === location.pathname ? 'accountsidebar__list__item--active' : ''}`} key={index}>
            <Link to={linkName.url}>{linkName.lable}</Link>
          </li>
        ))}
        <li className='accountsidebar__list__item' onClick={() => setLogoutModal(true)}>
          <span>Log out</span>
        </li>
      </ul>
      <LogoutModal logoutModal={logoutModal} setLogoutModal={setLogoutModal} />
    </div>
  );
};

export default AccountSidebar;
